import React from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import PropTypes from 'prop-types';
import { getColor, rgbaColor } from 'helpers/utils';
import * as echarts from 'echarts/core';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer,
  LegendComponent
]);

const getOption = datadump => ({
  title: {
    text: 'Attendance Distribution'
  },
  legend: {
    left: 'center',
    bottom: 3,
    itemWidth: 12,
    itemHeight: 12,
    borderRadius: 0,
    icon: 'circle',
    inactiveColor: getColor('gray-400'),
    inactiveBorderColor: 'transparent',
    textStyle: {
      color: getColor('gray-600'),
      fontSize: 10,
      fontFamily: 'Poppins',
      fontWeight: '500'
    },
    itemGap: 16
  },
  dataset: {
    source: datadump
  },
  series: [
    {
      type: 'pie',
      radius: ['40%', '70%'],
      edgeDistance: '5%',
      label: {
        show: false,
        fontSize: 8,
        borderType: 'none'
      },
      center: ['50%', '45%'],
      itemStyle: {
        borderWidth: 2,
        borderColor: getColor('gray-100')
      },
      color: [
        getColor('green'),
        rgbaColor(getColor('green'), 0.5),
        getColor('yellow'),
        getColor('red')
      ]
    }
  ],
  tooltip: {
    trigger: 'item',
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    transitionDuration: 0,
    axisPointer: {
      type: 'none'
    }
  }
});

const AttendanceChart = ({ datadump }) => {
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOption(datadump)}
      className="fs--3"
    />
  );
};

AttendanceChart.propTypes = {
  datadump: PropTypes.array.isRequired
};

export default AttendanceChart;
